import * as React from 'react';
import cn from 'classnames';

import { Icon } from 'admin/components/common/Icon';

import css from './Search.scss';

type Props = {
	className?: string;
	stylePreset?: 'default' | 'inline';
	'aria-label'?: string;
	onClear?: () => void;
	onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	placeholder?: string;
	value: string;
};

export const Search: React.FC<Props> = ({
	className = '',
	stylePreset = 'default',
	value,
	onClear = null,
	onSearchChange,
	placeholder = 'Search...',
	'aria-label': ariaLabel = placeholder,
}) => {
	return (
		<div className={cn(css.search, stylePreset === 'inline' && css.inline, className)}>
			<div className={css.searchInputWrap}>
				<input
					type="text"
					value={value}
					placeholder={placeholder}
					aria-label={ariaLabel}
					onChange={onSearchChange}
				/>
				<span className={css.searchBtn} aria-hidden="true">
					<Icon className={css.searchIcon} type="search" />
				</span>
				{onClear && value && (
					<button className={css.clearBtn} onClick={onClear} type="button" aria-label="Clear search" />
				)}
			</div>
		</div>
	);
};
